import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import AsyncStorage from '@react-native-async-storage/async-storage'
import { GetReferralStatsQuery } from '@api/mesa/graphql'

interface ReferralStatsStore {
  referralStats: GetReferralStatsQuery | undefined
  setReferralStats: (referralStats: GetReferralStatsQuery | undefined) => void
}

export const useReferralStatsStore = create(
  persist<ReferralStatsStore>(
    (set) => ({
      referralStats: undefined,
      setReferralStats: (referralStats: GetReferralStatsQuery | undefined) =>
        set({ referralStats }),
    }),
    {
      name: 'referral-stats-storage',
      storage: createJSONStorage(() => AsyncStorage),
    },
  ),
)
